























import { Component, Prop, Vue } from "vue-property-decorator";
import { Const } from '@/const';
import { Document } from '@/model/document2/document';
import { FileHelper } from '@/helper/fileHelper';
import { NameHelper } from '@/helper/nameHelper';
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
  }
})

export default class LargeImageAlert extends Vue 
{
    private callback : ((button : string) => void) | null = null;

    private isVisible = false;

    private title = "大きいサイズの画像です";
    private message1 = "指定された画像の解像度が高く、このまま貼りつけるとラベル屋さんの動作が不安定になることがあります。"
    private message2 = "印刷に適した解像度に変換しますか？"

    public open(callback : (button) => void)
    {
        this.isVisible = true;
        this.callback = callback;

        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    onClick(button : string)
    {
        DebugHelper.trace("Large Image Alert : " + button);
        
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
        this.isVisible = false;

        if(this.callback) this.callback(button);
    }

    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
